// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3BJEr","signatureBlock":"Footer_signatureBlock__AR4rN","signature":"Footer_signature__28KaP"};